/**
 * Knowledge Unit API client
 *
 * Single endpoint: GET /api/knowledge-units/:id
 * Returns a fully self-contained payload (unit + L2 + L3 + context)
 * so the KnowledgeUnitDetail widget can hydrate from one round-trip.
 */
import { apiClient } from './client';
import type {
  KnowledgeUnit,
  KnowledgeUnitSummary,
  KnowledgeUnitExtraction,
  KnowledgeUnitType,
  KnowledgeObjectKind,
} from '@shared/types/knowledge-base';

export interface KuNeighbor {
  id: string;
  ordinal: number;
  unit_type: KnowledgeUnitType;
  label: string | null;
}

export interface KnowledgeUnitDetail {
  unit: KnowledgeUnit;
  summary: KnowledgeUnitSummary | null;
  extractions: KnowledgeUnitExtraction[];
  context: {
    knowledge_object: {
      id: string;
      filename: string;
      kind: KnowledgeObjectKind;
      knowledge_base_id: string;
    };
    knowledge_base: {
      id: string;
      name: string;
    };
    neighbors: {
      previous: KuNeighbor | null;
      next: KuNeighbor | null;
    };
    total_units: number;
  };
}

export const knowledgeUnitApi = {
  /**
   * Fetch a single KU with all its layers (L2 summary, L3 extractions) and
   * surrounding context (parent KO/KB info, prev/next neighbor stubs).
   */
  getDetail: (unitId: string) =>
    apiClient.get<KnowledgeUnitDetail>(`/api/knowledge-units/${unitId}`),
};

// Made with Bob
